<template>
    <a class="rounded-none box has-hover-shadow is-paddingless"
       :href="this.activiteit.URI" :target="target">
        <div class="flex-row justify-between">
            <div class="py-4 mr-6">
                <b class="truncate-3-lines">
                    {{ activiteit.omschrijving }}
                </b>
            </div>
            <div class="justify-center w-1/5 pb-5 align-items-center">
                <calendar-date :date="nextMoment"></calendar-date>
            </div>
        </div>
        <hr class="is-marginless">
        <div class="flex-row py-2 mx-2">
            <div class="w-1/2 -ml-1">
                <p v-if="activiteit.startDatum"
                   :title="'Begindatum: ' + startMoment.format('D MMM YYYY')"
                   class="truncate has-text-size-13 nowrap is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-sm fa-play"></i>
                    </span>
                    {{ startMoment.format('D MMM YYYY') }}
                </p>
                <p v-if="activiteit.interval"
                   :title="'Frequentie: '+ activiteit.interval"
                   class="truncate has-text-size-13 nowrap is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-sync"></i>
                    </span>
                    {{ activiteit.interval }}
                </p>
            </div>
            <div class="w-1/2">
                <p v-if="activiteit.activiteittype"
                   :title="'Type activiteit: '+ activiteit.activiteittype"
                   class="truncate has-text-size-13 nowrap is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-sticky-note"></i>
                    </span>
                    {{ activiteit.activiteittype }}
                </p>
                <p v-if="activiteit.locatie"
                   :title="'Locatie van de activiteit: '+ activiteit.locatie"
                   class="truncate has-text-size-13 nowrap is-fullwidth">
                    <span class="icon">
                        <i class="fas fa-map-marker-alt"></i>
                    </span>
                    {{ activiteit.locatie }}
                </p>
            </div>
        </div>
        <hr class="is-marginless">
        <div v-bind:class="availabilityClass" class="flex-row items-baseline py-2 mx-2 space-x-4 font-bold has-text-size-12">
          <div class="-ml-1" v-bind:class="activiteit.prijs > 0 ? 'ml-1' : ''">
            <div
                v-html="availabilityMessage"></div>
          </div>
          <div class="w-1/2" v-show="activiteit.prijs > 0">
            <div>
              {{ formatCurrency }} p.p.
            </div>
          </div>
        </div>
    </a>
</template>


<script>
  import moment from 'moment';
  import 'moment/locale/nl';
  import CalendarDate from '../CalendarDate';

  export default {
    components: { CalendarDate },
    props: {
      activiteit: {},
      target: '_self'
    },
    created () {
      moment.locale('nl');
    },
    computed: {
      nextMoment () {
        return moment(this.activiteit.nextBijeenkomstDate, 'YYYY-MM-DD');
      },
      startMoment () {
        return moment(this.activiteit.startDatum, 'YYYY-MM-DD');
      },
      availabilityClass () {
        return {
           'has-text-success': this.activiteit.inschrijvingenMaximum === 0 || this.availablePlaces > 4,
           'has-text-warning': this.activiteit.inschrijvingenMaximum !== 0 && this.availablePlaces <= 4
        }
      },
      availablePlaces () {
          return this.activiteit.inschrijvingenMaximum - this.activiteit.inschrijvingen;
      },
      availabilityMessage () {
        if (Array.isArray(this.activiteit.inschrijvingen)) {
          return '';
        }
        if (this.activiteit.inschrijvingenMaximum === 0) {
          return `<div></div>`;
        }
        if (this.availablePlaces <= 0) {
          return `<div>Wachtlijst</div>`;
        }
        if (this.availablePlaces === 1) {
          return `<div><span class="icon"><i class="fas fa-loveseat"></i></span> Nog ${this.availablePlaces} plaats</div>`;
        }
        if (this.availablePlaces <= 4) {
          return `<div><span class="icon"><i class="fas fa-loveseat"></i></span> Nog ${this.availablePlaces} plaatsen</div>`;
        }
        return `<div><span class="icon"><i class="fas fa-loveseat"></i></span> Nog ${this.availablePlaces} plaatsen</div>`;
      },
      formatCurrency () {
        return Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(this.activiteit.prijs);
      }

      
    }
  };
</script>
<style scoped>
  .card {
    cursor: auto;
  }

  .card-header-title {
    padding: 0;
  }

  .card-footer-item {
    cursor: pointer;
  }
</style>
